export enum DataCollectionType {
  BallTypeCalibration = 'BTC',
  HardwareDiagnostic = 'HWD',
  RepeatabilityTest = 'RT',
}
